import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import './Age.scss';
import { OPTIONS } from './constants';

export const OnboardingReplikaAge: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Age',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const age = form.watch('age');

  const handleSelect = (option: OnbOptionType<LayoutDataType['age']>) => {
    userService.createOrUpdate({
      onboarding_data: {
        age: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage className="onboarding-age">
      <OnboardingNavigation />

      <IonContent>
        <OnboardingTitle className="onboarding-age__title">
          How old are you?
        </OnboardingTitle>
        <OnboardingOptionsList>
          {OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={age === option.id}
              control={form.control}
              option={option}
              name="age"
              key={option.id}
              onChange={() => handleSelect(option)}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
